<section class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto  p-2 lg:pl-0">
    <div
    [ngClass]="{
            'shadow-lg border border-zinc-950/10 dark:border-white/10': source !== 'modal'
          }"
        class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg">
        <form [formGroup]="userForm" (ngSubmit)="onSave()">

            <ng-container *ngIf="source !== 'modal'">
            
            <h1  class="heading">
                {{userId ? 'Edit' : 'Add'}}
            </h1>
            <hr class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <div >
                <h2 class="heading mb-4">
                    General Information
                </h2>
                <!-- <p class="text-sm-light">
                (Read Only)
            </p> -->
            </div>
            </ng-container>
            <section  class="grid gap-4 md:grid-cols-2 relative">

                <!-- Name -->
                <div class="space-y-1">
                    <label class="subheading">
                        Name <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="name" type="text" />
                        </div>
                    </div>
                    <div *ngIf="form.name.errors && submitted">
                        <div *ngIf="form.name.errors.required" class="error">
                            <p class="mt-2 text-red-600 text-xs">
                                Name is required
                            </p>
                        </div>
                    </div>
                </div>

                <!-- Email -->
                <div class="space-y-1">
                    <label class="subheading">
                        Email <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="email" autocomplete="off" type="text" />
                        </div>
                    </div>
                    <div *ngIf="submitted && form.email.errors">
                        <p *ngIf="form.email.errors.required" class="pt-1 text-red-600 text-xs">
                            Email is required
                        </p>
                        <p *ngIf="form.email.errors.email" class="pt-1 text-red-600 text-xs">
                            Invalid Email format
                        </p>
                    </div>
                </div>

                <!-- password -->

                <div class="space-y-1">
                    <label class="subheading">Password <span class="text-red-600">*</span></label>
                    <div class="flex flex-1 gap-2 items-center">
                        <div class="flex-1 relative">
                            <input formControlName="password" [type]="showPassword ? 'text' : 'password'" autocomplete="off"
                                class="input-class w-full pr-10" (input)="onInputChange($event)" />
                            <span class="absolute inset-y-0 right-2 flex items-center cursor-pointer text-gray-500"
                                (click)="togglePasswordVisibility()">
                                <ng-container *ngIf="showPassword; else hideIcon">
                                    <!-- Eye Slash Icon (Hide Password) -->
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                        stroke-width="1.5" stroke="currentColor" class="size-6">
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88" />
                                    </svg>
                                </ng-container>
                                <ng-template #hideIcon>
                                    <!-- Eye Icon (Show Password) -->
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                        stroke-width="1.5" stroke="currentColor" class="size-6">
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                    </svg>
                                </ng-template>
                            </span>
                        </div>
                    </div>

                    <div *ngIf="form.password?.errors && submitted">
                        <div *ngIf="form.password?.errors?.required" class="error">
                            <p class="mt-2 text-red-600 text-xs">Password is required</p>
                        </div>
                        <div *ngIf="form.password?.errors?.minlength" class="error">
                            <p class="mt-2 text-red-600 text-xs">
                                Password must be at least 8 chars with letters & numbers
                            </p>
                        </div>
                    </div>
                    <!-- <div *ngIf="form.password?.errors && (form.password?.dirty || form.password?.touched)">
                    <div *ngIf="form.password?.errors?.required" class="error">
                        <p class="mt-2 text-red-600 text-xs">Password is required</p>
                    </div>
                    <div *ngIf="form.password?.errors?.minlength" class="error">
                        <p class="mt-2 text-red-600 text-xs">Password must be at least 8 characters</p>
                    </div>
                </div> -->

                </div>

                <!-- Type -->
                <div class="space-y-1">
                    <label class="subheading">
                        Role <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                          
                             <ng-select [items]="roles" bindLabel="name" bindValue="id" placeholder="Select Role" [searchable]="true"
                                formControlName="role" (ngModelChange)="onRoleChange($event)">
                            </ng-select>
                        </div>
                    </div>
                    <div *ngIf="form.role.errors && submitted">
                        <div *ngIf="form.role.errors.required" class="error">
                            <p class="mt-2 text-red-600 text-xs">
                                Role is required
                            </p>
                        </div>
                    </div>
                </div>

                <div *ngIf="selectedRoleType === 'company'"  class="space-y-1">
                    <label class="subheading">
                        Company <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <ng-select [items]="types" bindLabel="name" bindValue="id" placeholder="Select Company" [searchable]="true" (change)="onSelectEntity($event)"
                                formControlName="company">
                            </ng-select>
                        </div>
                    </div>
                   <div *ngIf="form.company.errors && submitted">
                        <div *ngIf="form.company.errors.required" class="error">
                            <p class="mt-2 text-red-600 text-xs">
                                Company is required
                            </p>
                        </div>
                    </div>
                </div>
                <div *ngIf="selectedRoleType === 'member'"  class="space-y-1">
                    <label class="subheading">
                        Member <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <ng-select id="member" [notFoundText]="'No record found'" formControlName="member" [clearable]="true"
                                (scrollToEnd)="onScroll()" [searchable]="true" (search)="onSearch($event)" [searchable]="true" (clear)="onClear()"
                                (close)="onClose()" (change)="onSelectMember($event)" [ngClass]="
                                              submitted && form.member.errors?.required
                                                ? 'border-main-danger'
                                                : 'border-gray-300'
                                            " class="w-full">
                                <ng-option *ngIf="memberList.length > 0" value="">
                                    Select Member</ng-option>
                                <ng-option *ngFor="let member of memberList" value="{{ member.id }}">{{
                                    member.displayName +
                                    (member.contactNumber ? " - " + member.contactNumber : "")
                                    | titlecase
                                    }}</ng-option>
                            </ng-select>
                        </div>

                    </div>
                  <div *ngIf="form.member.errors && submitted">
                        <div *ngIf="form.member.errors.required" class="error">
                            <p class="mt-2 text-red-600 text-xs">
                                Member is required
                            </p>
                        </div>
                    </div>
                </div>
                <div *ngIf="selectedRoleType === 'fundingsource'"  class="space-y-1">
                    <label class="subheading">
                        Funding Source <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                           <ng-select [items]="types" bindLabel="title" bindValue="id" placeholder="Select Funding source" [searchable]="true" (change)="onSelectEntity($event)"
                                formControlName="fundingsource">
                            </ng-select>
                        </div>
                    </div>
                  <div *ngIf="form.fundingsource.errors && submitted">
                        <div *ngIf="form.fundingsource.errors.required" class="error">
                            <p class="mt-2 text-red-600 text-xs">
                                Funding Source is required
                            </p>
                        </div>
                    </div>
                </div>
                <!-- --status-- -->
                <div class="space-y-1">
                    <label class="subheading">
                        Status
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <select id="status" formControlName="isActive">
                                <option [value]="true">Active</option>
                                <option [value]="false">Inactive</option>
                            </select>
                        </div>
                    </div>
                    <div *ngIf="form.isActive.errors && submitted">
                        <div *ngIf="form.isActive.errors.required" class="error">
                            <p class="mt-2 text-red-600 text-xs">
                                Status is required
                            </p>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">Time Zone</label>
                    <div>
                      <select formControlName="timeZone">
                        <option *ngFor="let tz of timezones" [value]="tz">{{ tz }}</option>
                      </select>
                      <div *ngIf="submitted && form.timeZone.errors">
                        <p *ngIf="form.timeZone.errors.required" class="pt-1 text-red-600 text-xs">
                          Time Zone is required
                        </p>
                      </div>
                    </div>
                  </div>
                <!-- ----profile Image-- -->
                <div class="space-y-1 col-span-2 flex flex-col justify-start">
                    <label class="subheading w-full">Profile Image <span class="text-red-600">*</span></label>
                    <div class="flex gap-2">
                        <div>
                            <div class="relative overflow-hidden rounded-full mt-1 w-32 h-32">
                                <img [src]="profileImageURL ? profileImageURL : 'assets/images/profileImagePlaceholder.png'"
                                    alt="Profile Image"
                                    class="h-full w-full rounded-full border border-main-base object-cover" />
                                <label for="Profile"
                                    class="absolute inset-0 flex h-full w-full items-center justify-center bg-black bg-opacity-75 text-sm font-medium text-white opacity-0 focus-within:opacity-100 hover:opacity-100">
                                    <span>Change</span>
                                    <input #logoInput type="file" accept="image/*"
                                        (change)="processFile(logoInput)"
                                        id="Profile"
                                        name="Profile Image"
                                        class="absolute inset-0 h-full w-full cursor-pointer rounded-full border-main-base opacity-0" />
                                </label>
                            </div>
                            <div *ngIf="form.profileImageURL.errors && submitted">
                                <p *ngIf="form.profileImageURL.errors.required" class="mt-2 text-red-600 text-xs">
                                    Profile Image is required
                                </p>
                            </div>
                        </div>
                    </div>
                </div>


            </section>
            <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <section class="flex justify-end gap-4">
                <!-- <button class="btn-outline btn-outline-secondary">
                Approve
            </button> -->
                <button type="submit" class="btn btn-secondary">
                    {{userId ? 'Update' : 'Create'}}
                </button>
            </section>
        </form>
    </div>
</section>